export const DELIVERY_STATUSES: Record<string, common.DeliveryStatus> = {
  ToBeSent: 'To Be Sent',
  Dispatched: 'Dispatched',
  InProgress: 'In Progress',
  Delivered: 'Delivered',
};
